<h2 mat-dialog-title>{{ heading }}</h2>
<mat-dialog-content>
  <p>
    {{ message }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-raised-button
    color="primary"
    (click)="handleClose()"
    tabindex="1"
  >
    Logout
  </button>
</mat-dialog-actions>
